import { observer } from 'mobx-react-lite'
import React from 'react'
import { useStore } from '../../../../../../hooks/useStore'
import { ActivationPlaceholder } from '../activation-placeholder'
import {ShareCityListUI } from '../share-city-list-ui';
import { OrgListUI } from '../org-list-ui';
import { ShareCardPreview } from '../share-card-preview';

const ShareSectionContentSwitch = observer((props) => {
    const {uiStore: {home__share__isActive}} = useStore();
    return (
        <div>
            {!home__share__isActive ? <ActivationPlaceholder {...props}/> : <ActiveShareContent {...props}/>}
        </div>
    )
});


const ActiveShareContent = observer((props) => {
    const {uiStore: {home__share__showShareCard}} = useStore();
    return (
        <div>
            {
                home__share__showShareCard ?
                <ShareCardPreview/>
                :
                <>
                    <ShareCityListUI/>
                    <OrgListUI {...props}/>
                </>
            }

            <style jsx>{`
            `}</style>
        </div>
    )
});



export default ShareSectionContentSwitch